import dataAPI from "./dataAPI";
import boardAPI from "./boardAPI";

export default {
  async category_large(payload) {
    try {
      const Response = await dataAPI.category_large(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async category_medium(payload) {
    try {
      const Response = await dataAPI.category_medium(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async category_small(payload) {
    try {
      const Response = await dataAPI.category_small(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async menu(payload) {
    try {
      const Response = await dataAPI.menu(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async use_pers(payload) {
    try {
      const Response = await dataAPI.use_pers(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async use_pers_grp(payload) {
    try {
      const Response = await dataAPI.use_pers_grp(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async use_pers_grp_map(payload) {
    try {
      const Response = await dataAPI.use_pers_grp_map(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async auth(payload) {
    try {
      const Response = await dataAPI.auth(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async auth_grp(payload) {
    try {
      const Response = await dataAPI.auth_grp(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async auth_menu_map(payload) {
    try {
      const Response = await dataAPI.auth_menu_map(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async auth_use_pers_grp_map(payload) {
    try {
      const Response = await dataAPI.auth_use_pers_grp_map(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async meteCode(payload) {
    try {
      const Response = await dataAPI.meteCode(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async sysCode(payload) {
    try {
      const Response = await dataAPI.sysCode(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async board_calendar(payload) {
    try {
      const Response = await boardAPI.board_calendar(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async board_a(payload) {
    try {
      const Response = await boardAPI.board_a(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async board_files(payload) {
    try {
      const Response = await boardAPI.board_files(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async board_files_down(payload) {
    try {
      const Response = await boardAPI.board_files_down(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async kakao_auth(payload) {
    try {
      const Response = await boardAPI.kakao_auth(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async employee_info(payload) {
    try {
      const Response = await boardAPI.employee_info(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async client_info(payload) {
    try {
      const Response = await boardAPI.client_info(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async branch_info(payload) {
    try {
      const Response = await boardAPI.branch_info(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
};
